var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-content",style:({ backgroundImage:_vm.loginBg?`url(${_vm.loginBg})`:`url(${_vm.bg})`})},[_c('alogin2')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }